export default {
    X_SYNCAI_APP_ID: 'X-Syncai-App-Id',
    X_SYNCAI_APP_VERSION: 'X-Syncai-App-Version',
    X_SYNCAI_APP_UUID: 'X-Syncai-App-Uuid',
};
